export const FIXED_ATTRIBUTES = {
  servings: {
    label: 'Servings',
    name: 'servings',
    type: 'number'
  },
  shelf_life: {
    label: 'Shelf life',
    name: 'shelf_life',
    type: 'number'
  },
  price_per_serving: {
    label: 'Price per serving',
    name: 'price_per_serving',
    type: 'number'
  },
  faq: {
    label: 'Frequently Asked Questions',
    name: 'faq',
    type: 'text'
  },
  packaging: {
    label: 'Packaging Info',
    name: 'packaging',
    type: 'text'
  },
  cooking_instructions: {
    label: 'Cooking Instructions',
    name: 'cooking_instructions',
    type: 'text'
  },
  menu: {
    label: 'Menu Details',
    name: 'menu',
    type: 'text'
  },
  ingredients: {
    label: 'Ingredients',
    name: 'ingredients',
    type: 'text'
  },
  additional_information: {
    label: 'Additional Information',
    name: 'additional_information',
    type: 'text'
  },
  serving_suggestions: {
    label: 'Serving Suggestions',
    name: 'serving_suggestions',
    type: 'text'
  }
}
